// extracted by mini-css-extract-plugin
export default {"isBuilding":"IsBuilding_isBuilding__gThOW","wrapper":"IsBuilding_wrapper__SEN7p","iconBg":"IsBuilding_iconBg__uyZVO","des":"IsBuilding_des__Lmhah"};